module.exports = __webpack_public_path__ + "static/media/header-background.90b093cd.svg";